import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';

export const getIsZipGateRequired = (contest: FullContest | Contest): boolean =>
  !!contest.settings?.customContestSettings?.entryZipRequired && contest.entries.user === 0;
